import styles from '../styles/profileBanner.module.scss';
import defaultProfile from '../assets/profile.jpg';

export default function ProfileBanner({
    title = "",
    description,
    image = defaultProfile,
    imageAlt = "Profile"
}) {
    return (
        <section className={styles.profileBanner}>
            <div className={styles.content}>

                <div className={styles.textContent}>
                    {title && (
                        <h1 className={styles.title}>
                            {title}
                        </h1>
                    )}

                    <div className={styles.text}>
                        {description}
                    </div>
                </div>

                <div className={styles.imageContainer}>
                    <img
                        src={image}
                        alt={imageAlt}
                        className={styles.image}
                    />
                </div>

            </div>
        </section>
    );
}